import { getData, postData } from './api.service';

export interface OtpStatus {
  skipAllowed: boolean;
  skipsRemaining: number;
  totalAttempts: number;
}

export interface UserDetailsResponse {
  userName?: string;
  appName?: string;
  legacyAppEmail?: string;
  skipCount?: number;
  redirectUri?: string;
  error?: string;
}

export const useCaptureDetailsApi = () => {
  const skipOtp = (authStateKey: string): Promise<{ redirectUri?: string }> => {
    return postData<{ authStateKey: string }, { redirectUri?: string }>({
      url: '/sso/auth/email-capture/skip',
      body: { authStateKey },
    });
  };

  const generateOtp = (email: string, authStateKey: string): Promise<void> => {
    return postData<{ email: string; authStateKey: string }, void>({
      url: '/sso/auth/email-capture/otp/generate',
      body: { email, authStateKey },
    });
  };

  const validateOtp = (email: string, otp: string, authStateKey: string): Promise<{ redirectUri?: string }> => {
    return postData<{ email: string; otp: string; authStateKey: string }, { redirectUri?: string }>({
      url: '/sso/auth/email-capture/otp/validate',
      body: { email, otp, authStateKey },
    });
  };

  const fetchUserDetails = (authStateKey?: string): Promise<UserDetailsResponse> => {
    const query = authStateKey ? `?auth_state_key=${encodeURIComponent(authStateKey)}` : '';
    return getData<UserDetailsResponse>({
      url: `/sso/auth/email-capture/session${query}`,
    });
  };

  return {
    skipOtp,
    generateOtp,
    validateOtp,
    fetchUserDetails,
  };
};
